import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import Enquiries from './Enquiries'; 
import AddServices from './AddServices';
import Items from './Items';
import Orders from './Orders';
import logo from '../assets/logo/logo.png'; 
import '../App.css'; 

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('dashboard'); // Default dashboard ആക്കി
  const [enquiries, setEnquiries] = useState([]);
  const [servicesCount, setServicesCount] = useState(0);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/admin-login');
  };

  useEffect(() => {
    // Enquiries fetch
    const qEnquiries = query(collection(db, "contacts"), orderBy("submittedAt", "desc"));
    const unsubEnquiries = onSnapshot(qEnquiries, (querySnapshot) => {
      const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setEnquiries(data);
    });

    // Services count fetch (for dashboard stats)
    const qServices = query(collection(db, "services"));
    const unsubServices = onSnapshot(qServices, (snapshot) => {
      setServicesCount(snapshot.size);
    });

    return () => {
      unsubEnquiries();
      unsubServices();
    };
  }, []);

  return (
    <div className="admin-container">
      <aside className="admin-sidebar">
        <div className="sidebar-logo">
          <img src={logo} alt="Mr White Logo" />
        </div>
        <nav className="sidebar-nav">
          <div 
            className={`nav-item ${activeTab === 'dashboard' ? 'active' : ''}`} 
            onClick={() => setActiveTab('dashboard')}
          >
            <i className="fas fa-th-large"></i> Dashboard
          </div>
          <div className={`nav-item ${activeTab === 'enquiries' ? 'active' : ''}`} onClick={() => setActiveTab('enquiries')}>
            <i className="fas fa-envelope"></i> Enquiries
          </div>
          <div className={`nav-item ${activeTab === 'services' ? 'active' : ''}`} onClick={() => setActiveTab('services')}>
            <i className="fas fa-tshirt"></i> Services
          </div>
          <div className={`nav-item ${activeTab === 'items' ? 'active' : ''}`} onClick={() => setActiveTab('items')}>
          <i className="fas fa-list-ul"></i> Items
          </div>
          <div className={`nav-item ${activeTab === 'orders' ? 'active' : ''}`} onClick={() => setActiveTab('orders')}>
            <i className="fas fa-shopping-cart"></i> Orders
          </div>
          <div className={`nav-item ${activeTab === 'customers' ? 'active' : ''}`} onClick={() => setActiveTab('customers')}>
            <i className="fas fa-users"></i> Customers
          </div>
        </nav>
        <button onClick={handleLogout} className="sidebar-logout">
          <i className="fas fa-sign-out-alt"></i> Logout
        </button>
      </aside>

      <main className="admin-main">
        <header className="admin-topbar">
          <h1>
            {activeTab === 'dashboard' && "Dashboard Overview"}
            {activeTab === 'enquiries' && "Customer Enquiries"}
            {activeTab === 'services' && "Manage Services"}
            {activeTab === 'items' && "Manage items"}
            {activeTab === 'orders' && "Order Management"}
            {activeTab === 'customers' && "Customer Database"}
          </h1>

          <div className="admin-profile">
            <span>Welcome, Admin</span>
            <div className="profile-circle">A</div>
          </div>
        </header>

        <main className="admin-content">
           {/* സെക്ഷനുകൾ ഇവിടെ മാത്രം നൽകുക */}
           {activeTab === 'dashboard' && (
            <DashboardHome 
              enquiriesCount={enquiries.length} 
              servicesCount={servicesCount} 
            />
          )} 
           {activeTab === 'enquiries' && <Enquiries />}
           {activeTab === 'services' && <AddServices />}
           {activeTab === 'items' && <Items />}
           
           {activeTab === 'orders' && <Orders />}
           {activeTab === 'customers' && <div className="placeholder-content"><h3>Customer Database Coming Soon...</h3></div>}
        </main>
      </main>
    </div>
  );
}

// DashboardHome Component
function DashboardHome({ enquiriesCount, servicesCount }) {
  return (
    <div className="stats-row">
      <div className="stat-card">
        <div className="stat-icon"><i className="fas fa-envelope-open-text"></i></div>
        <div className="stat-info">
          <h4>Total Enquiries</h4>
          <p>{enquiriesCount}</p>
        </div>
      </div>
      
      <div className="stat-card">
        <div className="stat-icon"><i className="fas fa-concierge-bell"></i></div>
        <div className="stat-info">
          <h4>Active Services</h4>
          <p>{servicesCount}</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon"><i className="fas fa-clock"></i></div>
        <div className="stat-info">
          <h4>Today's Tasks</h4>
          <p>5</p>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;